<template>
  <div class="publicItems2">
    <el-card style="margin-bottom: 16px" shadow="never">
      <div class="selectionArea">
        <div class="item">
          <span class="item_title">小程序</span>
          <el-autocomplete
            v-model="parameterNames.app_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '小程序'"
            @clear="app_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">投放组</span>
          <el-autocomplete
            v-model="parameterNames.release_group_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '投放组'"
            @select="handleSelect"
            @clear="release_group_id = null"
          />
        </div>
        <div class="item">
          <span class="item_title">投手</span>
          <el-autocomplete
            v-model="parameterNames.pitcher_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '投手'"
            @select="handleSelect"
            @clear="pitcher_id = null"
          />
        </div>
        <div class="item">
          <span class="item_title">运营组</span>
          <el-autocomplete
            v-model="parameterNames.operation_group_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '运营组'"
            @clear="operation_group_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">运营者</span>
          <el-autocomplete
            v-model="parameterNames.operation_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '运营者'"
            @clear="operation_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">平台</span>
          <el-autocomplete
            v-model="parameterNames.platform_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请选择平台"
            :clearable="true"
            @focus="current = '平台'"
            @clear="platform_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">书籍归属</span>
          <el-autocomplete
            v-model="parameterNames.book_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '书籍归属'"
            @clear="book_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">书籍类型</span>
          <!-- <el-autocomplete
          v-model="parameterNames.belong_type_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书籍类型'"
          @clear="belong_type = null"
          @select="handleSelect"
        /> -->
          <el-select v-model="parameterNames.belong_type_name" clearable filterable placeholder="请选择类型">
            <el-option
              v-for="(item,index) in optionbook"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
        <div class="item">
          <span class="item_title">书名</span>
          <el-autocomplete
            v-model="parameterNames.alias_book_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '书名'"
            @clear="alias_book_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">投放位置</span>
          <el-autocomplete
            v-model="parameterNames.position_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '投放位置'"
            @clear="position_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">日期</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </div>
        <div v-if="currentDisplayType === 'chart'" class="item">
          <span class="item_title">投放平台类型</span>
          <el-select v-model="parameterNames.launch_platform_type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </div>
        <el-button style="height:37px" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
        <el-button style="height:37px" type="info" icon="el-icon-refresh-left" @click="reset">重置</el-button>
        <div class="right-box">
          <el-button v-if="currentDisplayType === 'list'" style="height:37px" type="success" @click="reportExport"><svg-icon style="margin-right: 4px" icon-class="DkIu" />导出总计报表</el-button>
          <el-button v-if="currentDisplayType === 'chart'" style="height:37px" type="success" @click="reportExportnew(0)"><svg-icon style="margin-right: 4px" icon-class="DkIu" />导出总计报表</el-button>
          <el-button v-if="currentDisplayType === 'chart'" style="height:37px" type="warning" @click="reportExportnew(1)"><svg-icon style="margin-right: 4px" icon-class="DkIuXdQy" />导出明细报表(日期)</el-button>
          <div class="style-tab">
            <div
              class="style-tubiao"
              :class="{ 'active-bg': currentDisplayType === 'chart' }"
              @click="switchToChart"
            >
              <div>新</div>
              <img style="height: 25px;width: 26px;" src="https://zyc.jingxuanhz.com/dj/img/operation/newlyinmessage/operationZDLOO202507251753415069269.png" alt="">
            </div>
            <span>|</span>
            <div
              class="style-liebiao"
              :class="{ 'active-bg': currentDisplayType === 'list' }"
              @click="switchToList"
            >
              <img style="height: 25px;width: 26px;" src="https://zyc.jingxuanhz.com/dj/img/operation/newlyinmessage/operationYKSWP202507251753415092479.png" alt="">
              <div>旧</div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <el-card v-if="currentDisplayType == 'list'" shadow="never">
      <div>
        <div class="content1">
          <div>
            合计
          </div>
          <div>
            <div>花费：</div>
            <div>{{ tableData.total_data && tableData.total_data.cost ? tableData.total_data.cost : 0 }}</div>
          </div>
          <div>
            <div>激活首日广告变现金额：</div>
            <div>{{ tableData.total_data && tableData.total_data.income_val_1 ? tableData.total_data.income_val_1 : 0 }}</div>
          </div>
          <div>
            <div>激活首日广告变现ROI：</div>
            <div>{{ tableData.total_data && tableData.total_data.income_roi_1 ? tableData.total_data.income_roi_1 : 0 }}</div>
          </div>
          <div>
            <div>广告变现金额：</div>
            <div>{{ tableData.total_data && tableData.total_data.ad_monetization_amount ? tableData.total_data.ad_monetization_amount : 0 }}</div>
          </div>
          <div>
            <div>roi达标率：</div>
            <div>{{ tableData.total_data && tableData.total_data.compliance_rate ? tableData.total_data.compliance_rate : 0 }}</div>
          </div>
        </div>
        <div>
          <el-table
            ref="tableRef"
            v-loading="loading"
            :data="tableData.list"
            max-height="650"
            style="width: 100%"
            border
            @sort-change="sortChange"
          >
            <el-table-column prop="channel_date" label="日期" width="150" />
            <el-table-column prop="release_group_name" label="投放组" width="120" />
            <el-table-column
              prop="operation_group_name"
              label="运营组"
              width="120"
            />
            <el-table-column prop="pitcher_name" label="投手姓名" />
            <el-table-column prop="platform_name" label="书城平台" width="120" />
            <el-table-column prop="position_name" label="投放位置" />
            <el-table-column prop="belong_name" label="归属书籍" width="120" />
            <el-table-column prop="belong_type" label="书籍类型" width="120" />
            <el-table-column prop="novel_name" label="书名" width="120" />
            <el-table-column prop="wechat_names" label="小程序名称" width="170" />
            <el-table-column prop="bind_id" label="绑定关系" width="110" />
            <!-- <el-table-column prop="roi_standard" label="ROI标准" /> -->
            <el-table-column prop="roi_standard" label="ROI标准" width="110" />
            <el-table-column prop="compliance_rate" label="ROI达标率" width="120" />
            <el-table-column
              prop="cost"
              label="花费"
              width="110"
              sortable="custom"
            />
            <el-table-column
              prop="ad_monetization_amount"
              label="广告变现金额"
              width="140"
              sortable="custom"
            />
            <el-table-column
              prop="income_val_1"
              label="激活首日广告变现金额"
              width="200"
              sortable="custom"
            />
            <el-table-column
              prop="income_roi_1"
              label="激活首日广告变现ROI"
              width="200"
            />
            <el-table-column
              prop="income_roi_3"
              label="激活3日广告变现ROI"
              width="200"
            />
            <el-table-column
              prop="income_roi_7"
              label="激活7日广告变现ROI"
              width="200"
            />
            <el-table-column
              prop="income_roi_14"
              label="激活14日广告变现ROI"
              width="200"
            />
            <el-table-column
              prop="cheout_fd_reward"
              label="点击首日付费ROI"
              width="200"
            />
            <el-table-column
              prop="reg_pv"
              label="注册次数"
              width="140"
            />
            <el-table-column
              prop="reg_cost"
              label="注册成本"
              width="140"
            />
          </el-table>
        </div>
        <pagination-right
          :total="tableData.count"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </div>
    </el-card>
    <div v-else>
      <div>
        <el-card
          shadow="never"
          class="total-box"
        >
          <div style="display: flex;justify-content: space-between;">
            <!-- 1. 花费 -->
            <div class="total-cell">
              <div class="total-img">
                <img
                  src="@/assets/images/13.小说/HwFz.webp"
                  alt=""
                >
              </div>
              <div class="total-data">
                <div>花费</div>
                <div>
                  <span>￥</span>
                  <count-to
                    v-if="newtableData.total_data && newtableData.total_data.cost !== undefined"
                    :key="newtableData.total_data.cost"
                    :start-val="0"
                    :end-val="Number(newtableData.total_data.cost)"
                    :duration="1500"
                    :decimals="getDecimals(newtableData.total_data.cost)"
                  />
                  <span v-else>--</span>
                </div>
              </div>
            </div>
            <!-- 1. 激活首日广告变现金额： -->
            <div class="total-cell">
              <div class="total-img">
                <img
                  src="@/assets/images/13.小说/JiHoUbRi.png"
                  alt=""
                >
              </div>
              <div class="total-data">
                <div>激活首日广告变现金额</div>
                <div>
                  <span>￥</span>
                  <count-to
                    v-if="newtableData.total_data && newtableData.total_data.income_val_1 !== undefined"
                    :key="newtableData.total_data.income_val_1"
                    :start-val="0"
                    :end-val="Number(newtableData.total_data.income_val_1)"
                    :duration="1500"
                    :decimals="getDecimals(newtableData.total_data.income_val_1)"
                  />
                  <span v-else>--</span>
                </div>
              </div>
            </div>

            <!-- 1. 激活首日广告变现ROI -->
            <div class="total-cell">
              <div class="total-img">
                <img
                  src="@/assets/images/13.小说/JiHoROI.webp"
                  alt=""
                >
              </div>
              <div class="total-data">
                <div>激活首日广告变现ROI</div>
                <div>
                  <count-to
                    :key="newtableData.total_data ? newtableData.total_data.income_roi_1 : 0"
                    :start-val="0"
                    :end-val="newtableData.total_data ? parseFloat(newtableData.total_data.income_roi_1) : 0"
                    :duration="1500"
                    :decimals="2"
                  />
                  <span>%</span>
                </div>
              </div>
            </div>

            <!-- 1. 广告变现金额 -->
            <div class="total-cell">
              <div class="total-img">
                <img
                  src="@/assets/images/13.小说/GdGkBmXm.webp"
                  alt=""
                >
              </div>
              <div class="total-data">
                <div>广告变现金额</div>
                <div>
                  <span>￥</span>
                  <count-to
                    v-if="newtableData.total_data && newtableData.total_data.ad_monetization_amount !== undefined"
                    :key="newtableData.total_data.ad_monetization_amount"
                    :start-val="0"
                    :end-val="Number(newtableData.total_data.ad_monetization_amount)"
                    :duration="1500"
                    :decimals="getDecimals(newtableData.total_data.ad_monetization_amount)"
                  />
                  <span v-else>--</span>
                </div>
              </div>
            </div>

            <!-- 1. roi达标率 -->
            <div class="total-cell">
              <div class="total-img">
                <img
                  src="@/assets/images/13.小说/ROIDaBc.webp"
                  alt=""
                >
              </div>
              <div class="total-data">
                <div>roi达标率</div>
                <div>
                  <count-to
                    :key="newtableData.total_data ? newtableData.total_data.compliance_rate : 0"
                    :start-val="0"
                    :end-val="newtableData.total_data ? parseFloat(newtableData.total_data.compliance_rate) : 0"
                    :duration="1500"
                    :decimals="2"
                  />
                  <span>%</span>
                </div>
              </div>
            </div>

          </div>
        </el-card>
        <el-card
          shadow="never"
          class="total-box"
          style="margin-top: 16px;"
        >
          <div>
            <el-table
              :data="newtableData.list"
              max-height="850"
              style="width: 100%"
              border
            >
              <el-table-column prop="channel_date" label="日期" width="150" />
              <el-table-column prop="release_group_name" label="投放组" width="120" />
              <el-table-column
                prop="operation_group_name"
                label="运营组"
                width="120"
              />
              <el-table-column prop="pitcher_name" label="投手姓名" />
              <el-table-column prop="platform_name" label="书城平台" width="120" />
              <el-table-column prop="position_name" label="投放位置" />
              <el-table-column prop="belong_name" label="归属书籍" width="120" />
              <el-table-column prop="belong_type" label="书籍类型" width="120" />
              <el-table-column prop="novel_name" label="书名" width="120" />
              <el-table-column prop="wechat_names" label="小程序名称" width="170" />
              <el-table-column prop="bind_id" label="绑定关系" width="110" />
              <!-- <el-table-column prop="roi_standard" label="ROI标准" /> -->
              <el-table-column prop="roi_standard" label="ROI标准" width="110" />
              <el-table-column prop="compliance_rate" label="ROI达标率" width="120" />
              <el-table-column
                prop="cost"
                label="花费"
                width="110"
                sortable="custom"
              />
              <el-table-column
                prop="ad_monetization_amount"
                label="广告变现金额"
                width="140"
                sortable="custom"
              />
              <el-table-column
                prop="income_val_1"
                label="激活首日广告变现金额"
                width="200"
                sortable="custom"
              />
              <el-table-column
                prop="income_roi_1"
                label="激活首日广告变现ROI"
                width="200"
              />
              <el-table-column
                prop="income_roi_3"
                label="激活3日广告变现ROI"
                width="200"
              />
              <el-table-column
                prop="income_roi_7"
                label="激活7日广告变现ROI"
                width="200"
              />
              <el-table-column
                prop="income_roi_14"
                label="激活14日广告变现ROI"
                width="200"
              />
              <el-table-column
                prop="cheout_fd_reward"
                label="点击首日付费ROI"
                width="200"
              />
              <el-table-column
                prop="reg_pv"
                label="注册次数"
                width="140"
              />
              <el-table-column
                prop="reg_cost"
                label="注册成本"
                width="140"
              />
            </el-table>
            <pagination-right
              :total="newtableData.count"
              :page-sizes="[10]"
              @size-change="fetchPageSizer"
              @current-change="fetchCurrentPager"
            />
          </div>
        </el-card>
        <el-card style="margin-top:16px" shadow="never">
          <!-- 图表容器 （示例4个） -->
          <div class="chart-layout">
            <div class="item" style="background-color: #FFFFFF;text-align: right;width: 100%">
              <span style="margin-right: 10px">投放组:</span>
              <el-autocomplete
                v-model="parameterNames.release_group_id_name"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入内容"
                :clearable="true"
                @focus="current = '投放组'"
                @select="handleSelect"
                @clear="release_group_id = null"
              />
            </div>
            <div
              v-if="currentDisplayType == 'chart'"
              ref="chart1"
              class="chart-item"
            />
          </div>
        </el-card>

        <el-card style="margin-top:16px" shadow="never">
          <div style="display:flex">
            <div
              v-if="currentDisplayType == 'chart'"
              ref="chart2"
              class="chart-item"
              style="width: 60vw"
            />
            <div>
              <div style="margin-bottom:16px">小程序注册数据</div>
              <div>
                <el-table
                  :data="newtabledatatwo"
                  border
                  style="width: 100%"
                  max-height="400"
                >
                  <el-table-column
                    prop="app_name"
                    label="小程序名称"
                    width="150"
                    align="center"
                  />
                  <el-table-column
                    prop="reg_pv"
                    label="注册量"
                    width="130"
                    align="center"
                  />
                  <el-table-column
                    prop="reg_cost"
                    label="注册成本"
                    align="center"
                  />
                </el-table>
                <pagination-right
                  :total="newcounttwo"
                  :page-sizes="[10]"
                  @size-change="fetchPageSizenewtwo"
                  @current-change="fetchCurrentPagenewtwo"
                />
              </div>
            </div>
          </div>
        </el-card>

        <el-card style="margin-top:16px" shadow="never">
          <div style="display:flex">
            <div
              ref="chart5"
              style="width:43.5vw !important"
              class="chart-item"
            />
            <div
              ref="chart3"
              style="width:43.5vw !important"
              class="chart-item"
            />
          </div>

        </el-card>

        <el-card style="margin-top:16px" shadow="never">
          <div style="display:flex">
            <div
              ref="chart4"
              style="width:43.5vw !important"
              class="chart-item"
            />
            <div
              ref="chart6"
              style="width:43.5vw !important"
              class="chart-item"
            />
          </div>

        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { getTotalReportList, getTheListOfOfficialAccount, getReleaseGroupList, getListOfPitchersInTheLaunchGroup, getOperationGroupList, getOperatorList, getTitleList, getBookOwnershipList, dropLocationList, modifyConsumption, exportTotalReport, updateReleaseBookType, exportTotalReportnew, commonreportoptions } from '@/api/copyReleaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getSelectList } from '@/api/report/SelectData.js'
import { iiianewlisttotalV2, iiianewlisttotalGraphics, iiianewechat } from '@/api/releaseGroup.js'
import CountTo from 'vue-count-to'
import * as echarts from 'echarts'
export default {
  components: {
    PaginationRight,
    CountTo
    /* Details */
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        app_id: null,
        release_group_id: null,
        pitcher_id: null,
        operation_group_id: null,
        operation_id: null,
        alias_book_id: null,
        book_id: null,
        belong_type: null,
        position_id: null,
        platform_id: null
      },
      parameterNames: {
        app_id_name: null, // 小程序
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        belong_type_name: null,
        position_id_name: null, // 投放位置
        platform_name: null,
        launch_platform_type: ''
      },
      current: null,
      date: [],
      activeItem: null,
      activeText: null,
      drawerItem: {},
      optionbook: [],
      order_by: {}, // 表格数据排序
      currentDisplayType: 'list', // 用于控制列表/图表显示模式
      newtableData: {},
      chart1: null,
      chart2: null,
      chart5: null,
      chart3: null,
      chart4: null,
      chart6: null,
      newtabledatatwo: [],
      newcounttwo: null,
      options: []
    }
  },
  created() {
    window.aa = this
    this.oplistr()
    if (this.currentDisplayType === 'list') {
      this.getDataList()
    } else {
      this.newlist()
      this.newlistpc()
      this.wechatlist()
    }
    if (this.optionbook.length >= 0) {
      this.booktypeList()
    }
  },
  methods: {
    async booktypeList() {
      const res = await updateReleaseBookType()
      this.optionbook = res.data
    },
    // 获取数据列表
    async getDataList(obj = {}) {
      if (JSON.stringify(this.order_by) === '{}') {
        this.order_by = {
          order: 'desc',
          field: 'channel_date'
        }
      }
      this.loading = true
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await getTotalReportList({ ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by:
          this.order_by && this.order_by.field && this.order_by.order
            ? this.order_by
            : null })
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    modify(row) {
      this.dialogVisible = true
      this.drawerItem = row
    },

    // 分页
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.search(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.search(true)
    },

    // 分页
    fetchPageSizer(s) {
      this.parameter.page_size = s
      const obj = {
        app_id: 'app_id_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        belong_type: 'belong_type_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && (this.parameter[key].value === this.parameterNames[obj[key]]) && key !== 'page' && key !== 'page_size') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'page_size') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      if (this.parameterNames.belong_type_name) {
        obj1.belong_type = this.parameterNames.belong_type_name
      }
      this.newlist(obj1)
    },

    // 分页
    fetchCurrentPager(s) {
      this.parameter.page = s
      const obj = {
        app_id: 'app_id_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        belong_type: 'belong_type_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && (this.parameter[key].value === this.parameterNames[obj[key]]) && key !== 'page' && key !== 'page_size') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'page_size') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      if (this.parameterNames.belong_type_name) {
        obj1.belong_type = this.parameterNames.belong_type_name
      }
      this.newlist(obj1)
    },
    fetchPageSizenewtwo(s) {
      this.parameter.page_size = s
      const obj = {
        app_id: 'app_id_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        belong_type: 'belong_type_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && (this.parameter[key].value === this.parameterNames[obj[key]]) && key !== 'page' && key !== 'page_size') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'page_size') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      if (this.parameterNames.belong_type_name) {
        obj1.belong_type = this.parameterNames.belong_type_name
      }
      this.wechatlist(obj1)
    },
    fetchCurrentPagenewtwo(s) {
      this.parameter.page = s
      const obj = {
        app_id: 'app_id_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        belong_type: 'belong_type_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && (this.parameter[key].value === this.parameterNames[obj[key]]) && key !== 'page' && key !== 'page_size') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'page_size') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      if (this.parameterNames.belong_type_name) {
        obj1.belong_type = this.parameterNames.belong_type_name
      }
      this.wechatlist(obj1)
    },
    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        '小程序': 'account_name',
        '投放组': 'release_group_name',
        '投手': 'user_name',
        '运营组': 'operation_group_name',
        '运营者': 'user_name',
        '书籍归属': 'book_name',
        '书名': 'novel_name',
        '投放位置': 'position_name'
      }

      switch (this.current) {
        case '小程序': currentFunc = getTheListOfOfficialAccount
          break
        case '投放组': currentFunc = getReleaseGroupList
          break
        case '投手': currentFunc = getListOfPitchersInTheLaunchGroup
          break
        case '运营组': currentFunc = getOperationGroupList
          break
        case '运营者': currentFunc = getOperatorList
          break
        case '书名': currentFunc = getTitleList
          break
        case '书籍类型': currentFunc = updateReleaseBookType
          break
        case '书籍归属': currentFunc = getBookOwnershipList
          break
        case '投放位置': currentFunc = dropLocationList
          break
        case '平台':
          currentFunc = getSelectList
          break
      }
      if (!currentFunc) {
        return
      }
      if (this.current === '投手' && !this.parameter.release_group_id || this.current === '运营者' && !this.parameter.operation_group_id || this.current === '书名' && !this.parameter.book_id) {
        const obj1 = {
          '投手': '请先选投放组，才能选投手',
          '运营者': '请先选运营组，才能选运营者',
          '书名': '请先选择书籍归属，才能选书名'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      const data = await currentFunc({
        name: queryString || null,
        group_id: this.current === '投手' ? this.parameter.release_group_id.address : this.current === '运营者' ? this.parameter.operation_group_id.address : null,
        book_belong_id: this.parameter.book_id ? this.parameter.book_id.address : null,
        type: this.current === '投放组' ? 2 : null
      })
      console.log(data)
      if (this.current === '书籍类型') {
        cb(data.data.map((item) => {
          return {
            value: item,
            address: item
          }
        }))
        return
      }
      if (this.current === '平台') {
        cb(
          data.data.platform.map(item => {
            return {
              value: item.name,
              address: item.id
            }
          })
        )
        return
      }
      if (this.current === '投手') {
        cb(
          data.data.group_user.map(item => {
            return {
              value: item.nickname,
              address: item.bind_id
            }
          })
        )
        return
      }
      cb(data.data.list.map((item) => {
        return {
          value: item[obj[this.current]],
          address: this.current === '小程序' ? item.app_id : item.id
        }
      }))
    },

    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '小程序' : this.parameter.app_id = item
          break
        case '投放组' : this.parameter.release_group_id = item
          break
        case '投手' : this.parameter.pitcher_id = item
          break
        case '运营组' : this.parameter.operation_group_id = item
          break
        case '运营者' : this.parameter.operation_id = item
          break
        case '书名' : this.parameter.alias_book_id = item
          break
        case '书籍归属' : this.parameter.book_id = item
          break
        case '书籍类型': this.parameter.belong_type = item
          break
        case '投放位置' : this.parameter.position_id = item
          break
        case '平台':
          this.parameter.platform_id = item
          break
      }
    },

    // 搜索
    search(value) {
      value || (this.parameter.page = 1)
      const obj = {
        app_id: 'app_id_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        belong_type: 'belong_type_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && (this.parameter[key].value === this.parameterNames[obj[key]]) && key !== 'page' && key !== 'page_size') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'page_size') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      if (this.parameterNames.belong_type_name) {
        obj1.belong_type = this.parameterNames.belong_type_name
      }
      obj1.launch_platform_type = this.parameterNames.launch_platform_type
      // eslint-disable-next-line eqeqeq
      if (this.currentDisplayType == 'list') {
        value === '导出' || this.getDataList(obj1)
      } else {
        this.newlist(obj1)
        this.newlistpc(obj1)
        this.wechatlist(obj1)
      }

      return obj1
    },

    // 重置
    reset(value) {
      this.parameter = {
        page: 1,
        page_size: 10,
        app_id: null,
        release_group_id: null,
        pitcher_id: null,
        operation_group_id: null,
        operation_id: null,
        alias_book_id: null,
        book_id: null,
        belong_type: null,
        position_id: null,
        platform_id: null
      }
      this.parameterNames = {
        app_id_name: null, // 小程序
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        belong_type_name: null,
        position_id_name: null, // 投放位置
        platform_name: null,
        launch_platform_type: ''
      }
      this.date = []
      this.current = null
      // eslint-disable-next-line eqeqeq
      if (this.currentDisplayType == 'list') {
        this.getDataList()
      } else {
        this.newlist()
        this.newlistpc()
        this.wechatlist()
      }
      // this.getDataList()
    },

    // 导出报表
    async reportExport() {
      const obj = this.search('导出')
      await exportTotalReport({ ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      this.reset('no')
    },
    // 导出报表
    async reportExportnew(status) {
      const obj = this.search('导出')
      await exportTotalReportnew({ ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        is_export_detail: status
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      this.reset('no')
    },

    async blur1() {
      if (this.activeItem.cost !== this.activeText) {
        try {
          await modifyConsumption({ id: this.activeItem.id, cost: this.activeText })
          this.$message({
            message: '修改花费成功',
            type: 'success'
          })
          this.getDataList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    },
    sortChange(cell) {
      console.log('cell:', cell)
      this.order_by['order'] = !cell.order
        ? cell.order : cell.order === 'ascending'
          ? 'asc' : 'desc'
      this.order_by['field'] = !cell.order
        ? cell.order : cell.prop
      this.search('排序')
    },
    switchToChart() {
      // this.currentDisplayType = 'chart'
      // this.search()

      this.currentDisplayType = 'chart'
      // 如果已经有值了，就不处理
      if (this.parameterNames.release_group_id_name) {
        this.search()
        return
      }
      // 设置当前 focus 类型
      this.current = '投放组'
      // 主动调用一次查询函数
      getReleaseGroupList({ name: null, type: 2 }).then((data) => {
        if (data?.data?.list?.length) {
          const firstItem = data.data.list[1]

          // 设置显示值（v-model 绑定）
          this.parameterNames.release_group_id_name = firstItem.release_group_name

          // 设置投放组 ID，用于级联逻辑
          this.release_group_id = {
            value: firstItem.release_group_name,
            address: firstItem.id
          }

          // 设置 parameter 里的值（你 querySearchAsync 判断依赖这个）
          this.parameter.release_group_id = this.release_group_id

          this.search()
        }
      })
    },
    switchToList() {
      this.currentDisplayType = 'list'
      this.search()
    },
    async newlist(obj = {}) {
      if (JSON.stringify(this.order_by) === '{}') {
        this.order_by = {
          order: 'desc',
          field: 'channel_date'
        }
      }
      // this.loading = true
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await iiianewlisttotalV2({ ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by:
          this.order_by && this.order_by.field && this.order_by.order
            ? this.order_by
            : null })
      console.log('列表', data)
      this.newtableData = data.data
      // this.tableData = data.data
      // this.loading = false
    },
    newlistpc(obj = {}) {
      if (JSON.stringify(this.order_by) === '{}') {
        this.order_by = {
          order: 'desc',
          field: 'channel_date'
        }
      }
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      iiianewlisttotalGraphics({ ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by:
          this.order_by && this.order_by.field && this.order_by.order
            ? this.order_by
            : null }).then((res) => {
        console.log('图表', res)
        this.disposeAllCharts()

        this.chart1 = echarts.init(this.$refs.chart1)
        this.chart1.setOption(this.getRechargeOption(res.data.income_roi_1))

        this.chart2 = echarts.init(this.$refs.chart2)
        this.chart2.setOption(this.getLineChartOption(res.data.income_val_1, res.data.ad_monetization_amount))

        if (this.$refs.chart5) {
          this.chart5 = echarts.init(this.$refs.chart5)
          this.chart5.setOption(this.getRechargeBarOption(res.data.cost))
        }
        if (this.$refs.chart3) {
          this.chart3 = echarts.init(this.$refs.chart3)
          this.chart3.setOption(this.getProfitOption(res.data.compliance_rate))
        }
        if (this.$refs.chart4) {
          this.chart4 = echarts.init(this.$refs.chart4)
          this.chart4.setOption(this.getnewfotoption(res.data.cheout_fd_reward))
        }
        this.chart6 = echarts.init(this.$refs.chart6)
        this.chart6.setOption(this.getRateOptionsr(res.data.platform_statistics, res.data.total_platform_data_count))
      })
    },
    getDecimals(val) {
      if (!val || isNaN(val)) return 0
      const strVal = val.toString()
      const parts = strVal.split('.')
      return parts.length > 1 ? parts[1].length : 0
    },
    disposeAllCharts() {
      if (this.chart1) {
        this.chart1.dispose()
        this.chart1 = null
      }
      if (this.chart2) {
        this.chart2.dispose()
        this.chart2 = null
      }
      if (this.chart3) {
        this.chart3.dispose()
        this.chart3 = null
      }
      if (this.chart4) {
        this.chart4.dispose()
        this.chart4 = null
      }
      if (this.chart5) {
        this.chart5.dispose()
        this.chart5 = null
      }
      if (this.chart6) {
        this.chart6.dispose()
        this.chart6 = null
      }
      window.removeEventListener('resize', this.handleResize)
    },
    handleResize() {
      this.chart1 && this.chart1.resize()
      this.chart2 && this.chart2.resize()
      this.chart3 && this.chart3.resize()
      this.chart4 && this.chart4.resize()
      this.chart5 && this.chart5.resize()
      this.chart6 && this.chart6.resize()
    },

    getRechargeOption(new_user_roi_list) {
      const xData = new_user_roi_list.map(item => item.name)
      const yData = new_user_roi_list.map(item => {
        // 移除百分号后转为数字
        const num = parseFloat(item.value?.replace('%', ''))
        return isNaN(num) ? 0 : num
      })

      return {
        title: { text: '激活广告变现ROI（%）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          name: '%',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: 'ROI',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#008DFF'
            },
            itemStyle: {
              color: '#008DFF',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(0,141,255,0.4)' },
                  { offset: 1, color: 'rgba(0,141,255,0)' }
                ],
                false
              )
            },
            label: {
              show: true,
              formatter: '{c}%' // 显示百分号
            }
          }
        ]
      }
    },
    getLineChartOption(incomeVal = [], adMonetization = []) {
      const xData = incomeVal.map(item => item.name)

      const incomeMap = Object.fromEntries(incomeVal.map(item => [item.name, item.value]))
      const adMap = Object.fromEntries(adMonetization.map(item => [item.name, item.value]))

      const incomeSeries = xData.map(name => incomeMap[name] || '')
      const adSeries = xData.map(name => adMap[name] || '')

      return {
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            const name = params[0].name
            const lines = params.map(p => `${p.seriesName}：${p.data}`).join('<br/>')
            return `${name}<br/>${lines}`
          }
        },
        legend: {
          data: ['激活首日广告变现金额', '广告变现收入']
        },
        grid: {
          left: 40,
          right: 20,
          top: 60,
          bottom: 30
        },
        xAxis: {
          type: 'category',
          data: xData
        },
        yAxis: {
          type: 'value',
          name: '金额',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            name: '激活首日广告变现金额',
            type: 'line',
            data: incomeSeries.map(v => parseFloat(v)), // 转成数字用于绘图
            label: {
              show: true,
              position: 'top',
              formatter: function(v) {
                return incomeVal[v.dataIndex]?.value || ''
              }
            },
            lineStyle: { color: '#00c0ff' },
            itemStyle: { color: '#00c0ff' }
          },
          {
            name: '广告变现收入',
            type: 'line',
            data: adSeries.map(v => parseFloat(v)),
            label: {
              show: true,
              position: 'top',
              formatter: function(v) {
                return adMonetization[v.dataIndex]?.value || ''
              }
            },
            lineStyle: { color: '#ff7f50' },
            itemStyle: { color: '#ff7f50' }
          }
        ]
      }
    },
    getRechargeBarOption(costArr) {
      const names = costArr.map(item => item.name)
      const values = costArr.map(item => parseFloat(item.value))

      return {
        title: {
          text: '花费（元）',
          left: 'left'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 60,
          bottom: 30
        },
        xAxis: {
          type: 'category',
          data: names,
          axisLabel: {
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          name: '金额（元）'
        },
        series: [{
          data: values,
          type: 'bar',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#008DFF' },
              { offset: 1, color: '#008DFF' }
            ])
          }
        }]
      }
    },
    getProfitOption(compliancerate) {
      const xData = compliancerate.map(item => item.name)
      const yData = compliancerate.map(item => {
        // 移除百分号后转为数字
        const num = parseFloat(item.value?.replace('%', ''))
        return isNaN(num) ? 0 : num
      })

      return {
        title: { text: 'ROI达标率（%）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          name: '%',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: 'ROI达标率',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#008DFF'
            },
            itemStyle: {
              color: '#008DFF',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(0,141,255,0.4)' },
                  { offset: 1, color: 'rgba(0,141,255,0)' }
                ],
                false
              )
            },
            label: {
              show: true,
              formatter: '{c}%' // 显示百分号
            }
          }
        ]
      }
    },
    getnewfotoption(cheoutfdreward) {
      const xData = cheoutfdreward.map(item => item.name)
      const yData = cheoutfdreward.map(item => {
        // 移除百分号后转为数字
        const num = parseFloat(item.value?.replace('%', ''))
        return isNaN(num) ? 0 : num
      })

      return {
        title: { text: '点击首日付费ROI（%）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          name: '%',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '首日付费ROI',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#008DFF'
            },
            itemStyle: {
              color: '#008DFF',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(0,141,255,0.4)' },
                  { offset: 1, color: 'rgba(0,141,255,0)' }
                ],
                false
              )
            },
            label: {
              show: true,
              formatter: '{c}%' // 显示百分号
            }
          }
        ]
      }
    },
    getRateOptionsr(platform_statistics, total_platform_data_count) {
      const total = platform_statistics.reduce((sum, item) => sum + Number(item.value), 0)
      const pieData = platform_statistics.map(item => ({
        name: item.name,
        value: Number(item.value)
      }))

      return {
        // title: {
        //   text: '书城平台\n' + total_platform_data_count,
        //   left: 'center',
        //   top: '42%',
        //   textStyle: {
        //     fontSize: 14,
        //     fontWeight: 'normal',
        //     lineHeight: 22,
        //     color: '#333',
        //     rich: {
        //       a: { fontSize: 16, fontWeight: 'bold' }
        //     }
        //   }
        // },
        title: {
          text: `{a|书城平台}\n{b|${total_platform_data_count}}`,
          left: '31%', // 与 series.center[0] 一致
          top: '45%', // 可以微调这个值，居中效果更好
          textStyle: {
            rich: {
              a: {
                fontSize: 14,
                color: '#666',
                align: 'center',
                lineHeight: 22
              },
              b: {
                fontSize: 20,
                fontWeight: 'bold',
                color: '#333',
                align: 'center',
                lineHeight: 28
              }
            }
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 20,
          top: 'center',
          itemGap: 16,
          textStyle: {
            fontSize: 12,
            color: '#666'
          },
          formatter: name => {
            const item = pieData.find(i => i.name === name)
            const percent = ((item.value / total) * 100).toFixed(2)
            return `${name}  ${percent}%`
          }
        },
        series: [
          {
            name: '投放平台',
            type: 'pie',
            radius: ['55%', '75%'],
            center: ['35%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            data: pieData,
            color: ['#4DB6E2', '#00C1D4', '#5E83FB', '#008DFF', '#D3DCE6']
          }
        ]
      }
    },
    async wechatlist(obj = {}) {
      if (JSON.stringify(this.order_by) === '{}') {
        this.order_by = {
          order: 'desc',
          field: 'channel_date'
        }
      }
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await iiianewechat({ ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by:
          this.order_by && this.order_by.field && this.order_by.order
            ? this.order_by
            : null })
      console.log('小程序注册数', data)
      this.newtabledatatwo = data.data.list
      this.newcounttwo = data.data.count
    },
    async oplistr() {
      const res = await commonreportoptions()
      this.options = res.data.launch_platform_type
    }
  }
}
</script>

<style scoped lang="less">
.content{
   .item{
     display: flex;
     align-items: center;
    .item_title{
       display: inline-block;
       width: 100px;
    }
    .item_input{
       width: 200px
    }
   }
}

.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
       margin-right: 10px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
  .right-box {
    margin-left: auto;  // 自动推到最右边
    text-align: right;
    display: flex;
  }
}

 .powder {
   background: rgb(248, 216, 216);
 }
 .green {
   background: rgb(52, 229, 54);
 }
 .yellow {
   background: rgb(255, 247, 173);
 }
 .blue {
   background: rgb(158, 211, 252);
 }
 .red {
   background: #ffa500;
 }
 .magRig {
   margin-right: 10px;
 }
 .magLfte {
   margin-left: 10px;
 }
 .chong{
          display: inline-block;
          width: 13px;
          height: 86%;
          margin-left: 6px;
    }
    .mybox{
      margin-left: 20px;
      display: flex;
      align-items: center;
    }

    .el-dialog{
  margin-top: 6vh !important;

}
.content1{
  padding: 13px;
  color: #000;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
}
.publicItems2 {
  padding: 24px;
}
.content1>div:nth-child(1){
  margin-right: 7rem;
}
.content1>div{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 3rem;
}
.content1>div>div:nth-child(2){
  color: rgb(138, 37, 37);
}

.style-tab {
  width: 124px;
  height: 36px;
  background-color: #f2f3f5;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  div {
    width: 42px;
    height: 24px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    img {
      width: 16px;
      height: 16px;
    }
  }
  span {
    margin: 0px 5px;
    color: #ccc;
  }
}
/* 当处于激活状态时，设置背景为白色 */
.active-bg {
  background-color: #ffffff;
}
.total-cell {
  width: 200px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  .total-img {
    img {
      width: 56px;
      height: 56px;
    }
  }
  .total-data {
    font-size: 18px;
    color: #1d2129;
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-left: 10px;
    justify-content: space-between;

    div:nth-of-type(1) {
      font-size: 16px;
      color: #4e5969;
    }
    div:nth-of-type(2) {
      font-weight: bold;
    }
    span {
      font-size: 16px;
    }
  }
}
.chart-layout {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background-color: #f1f2f5;
}
.chart-item {
  width: 43.5vw;
  height: 426px !important;
  padding: 20px;
  border-radius: 5px;
  background: #fff;
}
.chart-item:last-of-type {
  width: 100% !important;
}
.selectionArea {
  @success-rgb: 0, 180, 42;
  @warning-rgb: 255, 125, 0;

  /* 针对 type 为 success 的按钮（plain 或非 plain）*/
  /deep/ .el-button--success,
  /deep/ .el-button--success.is-plain {
    background-color: rgba(@success-rgb, 0.08) !important;
    color: #00B42A !important;
    border: 1px solid #00B42A !important;
    border-radius: 4px !important;
    height: 37px !important;
    padding: 0 10px !important;
  }
  /deep/ .el-button--success:hover,
  /deep/ .el-button--success.is-plain:hover { background-color: rgba(@success-rgb, 0.15) !important; }
  /deep/ .el-button--success:active,
  /deep/ .el-button--success.is-active { background-color: rgba(@success-rgb, 0.25) !important; }

  /* warning 同理 */
  /deep/ .el-button--warning,
  /deep/ .el-button--warning.is-plain {
    background-color: rgba(@warning-rgb, 0.08) !important;
    color: #FF7D00 !important;
    border: 1px solid #FF7D00 !important;
    border-radius: 4px !important;
    height: 37px !important;
    padding: 0 10px !important;
  }
  /deep/ .el-button--warning:hover,
  /deep/ .el-button--warning.is-plain:hover { background-color: rgba(@warning-rgb, 0.15) !important; }
  /deep/ .el-button--warning:active,
  /deep/ .el-button--warning.is-active { background-color: rgba(@warning-rgb, 0.25) !important; }
  /deep/ .el-input {
    width: 200px;
  }
}
</style>
